import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JMigratorService } from './JMigrator.Service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
  selector: 'app-username-configuration',
  standalone: false,
  templateUrl: './username-configuration.component.html',
  styleUrls: ['./username-configuration.component.scss']
})


export class UsernameConfigurationComponent implements OnInit {
  usernameConfigForm: UntypedFormGroup;
  buttonColor = "";
  

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data:any,
    private dialogRef: MatDialogRef<UsernameConfigurationComponent>,
    private migratorService: JMigratorService,
    private spinner: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    private localStorageSettings: LocalStorageSettingsService,
  ) {
    this.usernameConfigForm = new UntypedFormGroup({
      userName: new UntypedFormControl('', Validators.required),
      failedUserName: new UntypedFormControl('', Validators.required)
    });

  }

  ngOnInit(): void {
    this.loadUsernameConfig();
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }

  loadUsernameConfig() {

  this.spinner.start();

  this.migratorService
      .getDataExtractorUsernameConfig()
      .subscribe({

        next: (response:any) => {

          console.log(response);

          this.usernameConfigForm.patchValue({

            userName: response.newRunUsername,

            failedUserName: response.failedRunUsername

          });

          this.spinner.stop();

        },

        error:(err)=>{

          console.log(err);

          this.spinner.stop();

        }

      });

}
  


  save(): void {
    if (this.usernameConfigForm.invalid) {
      return;
    }

    const payload = {
      newRunUsername:
        this.usernameConfigForm.value.userName,
    failedRunUsername:
        this.usernameConfigForm.value.failedUserName
    };

    this.spinner.start();
    this.migratorService.updateDataExtractorUsernameConfig(payload).subscribe({
      next: () => {
        this.spinner.stop();
        this.snackBar.open('Username configuration saved', 'OK', { duration: 5000 });
        this.dialogRef.close(true);
      },
      error: () => {
        this.spinner.stop();
        this.snackBar.open('Unable to save username configuration', 'OK', { duration: 5000 });
      }
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}